import React, { useEffect, useState } from "react";
import cryptoList from "../cryptoInfo.json"
import CoinListItem from "./coinListItem";
import dataServ from "../services/dataService"
import localforage from "localforage";

export default function PreferenceTracker({ triggerRender }) {
    const [currentSearch, onSearchChange] = useState("")
    const [coinsList, setCoinList] = useState([])
    const [addButtonMessage, setAddButtonMessage] = useState("Add")

    //fetch coinList from localStorage on Mount

    function handleSearchChange(e) {
        onSearchChange(e.target.value)
    }

    useEffect(() => {
        localforage.getItem("preferences").then((item) => {
            if (item != null) {
                setCoinList(item)
            }
        })
    }, [])

    function addCoin() {
        let coins = cryptoList.data
        let coinExists = false
        setAddButtonMessage("Adding...")
        for (var coin of coins) {
            if (coin.name.toLowerCase() == currentSearch.toLowerCase()) {
                coinExists = true
                let coinsListTemp = coinsList.slice()
                const coinItem = { coinName: coin.name, coinSymbol: coin.symbol, coinId: coin.id, upper: 0, lower: 0 }
                dataServ.addCoinDB(coin.id, coin.name, coin.symbol, 0, 0).then(res => {
                    coinsListTemp.push(coinItem)
                    localforage.setItem("preferences", coinsListTemp)
                    setCoinList(coinsListTemp)
                    setAddButtonMessage("Add")
                    onSearchChange("")
                    triggerRender()
                })
            }
        }
        if (!coinExists) {
            onSearchChange("coin not found in database")
            setAddButtonMessage("Add")

        }

    }

    return (
        <div className="prefTracker col">
            <div className="coinAddBar row">
                <input className="coinSearchBar" value={currentSearch} onChange={(event) => { handleSearchChange(event) }} placeholder="type coin name to add">

                </input>
                <button className="addButton" onClick={addCoin}>
                    {addButtonMessage}
                </button>
            </div>
            <div className="coinList col">

                {coinsList ? coinsList.map((item) => (
                    <CoinListItem key={item.coinName} name={item.coinName} symbol={item.coinSymbol} id={item.coinId} upper={item.upper} lower={item.lower} />
                )) : null}
            </div>

        </div>

    )
}